module.exports = __webpack_public_path__ + "img/paddle-icon.788edf03.jpeg";